var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_712_7699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4061 0H13.0225C5.83036 0 0 5.83036 0 13.0225V38.4061C0 45.5982 5.83036 51.4286 13.0225 51.4286H38.4061C45.5982 51.4286 51.4286 45.5982 51.4286 38.4061V13.0225C51.4286 5.83036 45.5982 0 38.4061 0Z",
    fill: "url(#paint0_linear_712_7699)",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5266 13.8082L39.8535 11.5713V25.0224L24.5266 25.1441V13.8082ZM23.1308 14.0142L11.5713 15.5885L11.5818 25.2301L23.1358 25.1643L23.1308 14.0142ZM23.134 37.6084L23.125 26.4486L11.5794 26.3738L11.58 36.0199L23.134 37.6084ZM39.8536 39.9444L39.8572 26.5539L24.5052 26.5288L24.5267 37.7812L39.8536 39.9444Z",
    fill: "#00ADEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_712_7699",
    x: -20,
    y: -20,
    width: 91.4287,
    height: 91.4287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_712_7699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_712_7699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_7699",
    x1: 26.3809,
    y1: -8.95808,
    x2: 24.4228,
    y2: 92.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FAFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinIcon);
export default __webpack_public_path__ + "static/media/win-icon.6773de325f5d76b1e48b0c08a26ce922.svg";
export { ForwardRef as ReactComponent };